(function(window, undefined) {
  'use strict';

    // ScrollToTop
    var scrollTopBtn = document.getElementById("scrollTopBtn");
    window.onscroll = function() {scrollFunction()};
    function scrollFunction() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            scrollTopBtn.style.display = "block";
        } else {
            scrollTopBtn.style.display = "none";
        }
    }
    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    if($('.product-quantity').length){
        var qty = $(".product-quantity .form-control").data('identifier');
        $(".product-quantity .form-control").TouchSpin({
            min: 1,
            max: qty,
            buttondown_class: "btn quantity-down",
            buttonup_class: "btn quantity-up"
        });
        $(".quantity-down").html("<i class='fa fa-angle-down'></i>");
        $(".quantity-up").html("<i class='fa fa-angle-up'></i>");
    }

    if($('.bs-select').length){
        $('.bs-select').selectpicker({
            iconBase: 'fa',
            tickIcon: 'fa-check'
        });
    }

})(window);
